/** POS V2 — ligne vente hors stock (pas commande/acompte). */

export function buildHorsStockSaleLine({ designation, prix, quantite = 1 }) {
  const label = (designation || '').trim();
  const unit = parseFloat(prix);
  const qty = Math.max(1, parseInt(quantite, 10) || 1);
  if (!label || !unit || unit <= 0) return null;
  return {
    produit_ref: 'HORS-STOCK',
    designation: label,
    quantite: qty,
    prix_unitaire: unit,
    prix_total: unit * qty,
    stock_magasin_id: null,
    is_hors_stock: true,
  };
}
